import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { openModal } from "../../actions/modalAction";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { fetchUser, resetUser } from "../../actions/authAction";
import { withRouter } from "react-router-dom";

import { Segment, Form, Button, Icon, Container } from "semantic-ui-react";
import TextInput from "../form/TextInput";

import SelectInput from "../form/SelectInput";

const userTypeA = ["admin", "manager_dwk","manager_ggn", "visiter", "account"];
const userType = () => {
  return userTypeA.map(value => ({
    key: value,
    text: value,
    value: value
  }));
};

// const optionsA = ["Yes", "No"];
// const options = () => {
//   return optionsA.map((value) => ({
//     key: value,
//     text: value,
//     value: value,
//     style: { fontSize: "18px" },
//   }));
// };

class UserEdit extends Component {
  componentDidMount() {
    const { id } = this.props;
    this.props.fetchUser(id);
  }
  componentWillUnmount() {
    this.props.resetUser();
  }
  onSubmit = async (values) => {
    //************
    try {
      const { id } = this.props;
      const res = await axios.put(`/api/UserEdit/${id}`, values);

      if (res.data.msg === "success") {
        toastr.success("Updated Successfully");
        this.props.handleEditModalCloseSubmit();
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        this.props.openModal("LoginModal");
        toastr.error(`${JSON.stringify(error.response.data)}`);
      } else if (error) {
        toastr.error("Oops", "Something went wrong.Please Try Again");
      }
    }
    //**********
  };

  //********************
  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    if ((this.props.user !== null && this.props.user.superAdmin === true)
    || (this.props.userA !== null && this.props.userA.userType === 'admin')
    ) {
      return (
        <div
          className="font-family-Roboto"
          style={{ maxWidth: "700px", margin: "auto" }}
        >
          {/**/}
          <div
            className="card-attached border-radius-top "
            style={{ textAlign: "center", backgroundColor: "skyblue" }}
          >
            <div
              style={{
                fontSize: "1.3rem",
                fontWeight: "bold",
                padding: "10px",
              }}
            >
              {/*  */}
              Edit User
              {/*  */}
            </div>
          </div>
          {/**/}
          <div className="card-attached border-radius-bottom pxy-20">
            <div className=" label">
              <Form
                style={{ padding: 10 }}
                onSubmit={handleSubmit(this.onSubmit)}
              >
                <Button
                  color="teal"
                  type="button"
                  onClick={this.props.handleEditModalClose}
                >
                  Cancel
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
                <br />
                <br />
                <div>
                  <span className="color-mandatory">* </span>Mandatory Fields
                </div>
                <br />
                <label>User's Name</label>
                <Field
                  name="uname"
                  type="text"
                  component={TextInput}
                  placeholder="User's Name"
                />
                {(this.props.user !== null && this.props.user.superAdmin === true)
            && 
            <>
            <label >User's Mobile as user ID</label>
              <Field
                name="userId"
                type="text"
                component={TextInput}
                placeholder="User's Mobile as user ID"
              />
            </>
            }
                {/* <label >User's Mobile as user ID</label>
              <Field
                name="userId"
                type="text"
                component={TextInput}
                placeholder="User's Mobile as user ID"
              />
              <label >User's Phone1</label>
                <Field
                  name="uphone1"
                  type="text"
                  component={TextInput}
                  placeholder="Phone1"
                /> */}
                <label>User's Phone1</label>
                <Field
                  name="uphone1"
                  type="text"
                  component={TextInput}
                  placeholder="Phone1"
                />

                <label>User's Phone2</label>
                <Field
                  name="uphone2"
                  type="text"
                  component={TextInput}
                  placeholder="Phone2"
                />
                <label>User's Email</label>
                <Field
                  name="uemail"
                  type="email"
                  component={TextInput}
                  placeholder="User's Email"
                />
                
           {(this.props.user !== null && this.props.user.superAdmin === true)
            && 
            <>
            <label >User Type</label>
            <Field
              name="userType"
              placeholder="User Type"
              type="text"
              options={userType()}
              //search={true}
              component={SelectInput}
            />
            </>
            }

                <br />

                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Submit
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>
              </Form>
              <br />
              <br />
              <br />
            </div>
          </div>
        </div>
      );
    }
    return (
      <Container text>
        <Segment>
          <button
            onClick={this.props.handleEditModalClose}
            className="back-btn"
          >
            <Icon name="arrow left" />
          </button>
          <div style={{ color: "red", textAlign: "center" }}>
            <h2>You Are Not Authorised To Edit User </h2>
          </div>
        </Segment>
      </Container>
    );
  }
}

export default connect(
  (state) => {
    return {
      employees: state.auth.employees,
      user: state.auth.user,
      userA: state.auth.userA,
      userD: state.auth.userD,
      initialValues: state.auth.userD, // pull initial values from auth reducer
    };
  },
  { fetchUser, resetUser, openModal }
)(
  reduxForm({
    form: "UserEditA", // a unique identifier for this form
    // validate
  })(withRouter(UserEdit))
);
